import React, { useState, useEffect } from 'react';
import './../App.css'; // Assuming you have a CSS file for styling
import logo from './../assets/logo_150.svg'; // Import logo.svg from the assets folder
import Header from './../components/Header';
import Footer from '../components/Footer';

const CommunityGuidelinesPage = () => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const position = window.pageYOffset;
            setScrollPosition(position);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="app">
            <Header scrolled={scrollPosition > 0} />
            <div className="content article">
                <h1>Правила сообщества</h1>
                <p>
                    Ниже представлены актуальные правила сообщества, которые нужно соблюдать, загружая контент на нашу платформу:
                    <br />
                    <ul>
                        <li>
                            Не размещайте рекламу, не пытайтесь абузить механики сайта
                        </li>
                        <li>
                            Не размещайте спойлеры, не портите впечатление от просмотра другим пользователям
                        </li>
                        <li>
                            Уважайте других участников сообщества. Не публикуйте оскорбительный или унизительный контент.
                        </li>
                        <li>
                            Соблюдайте авторские права. Не загружайте контент, защищенный авторским правом, без разрешения владельца.
                        </li>
                        <li>
                            Не публикуйте непристойный или порнографический контент.
                        </li>
                        <li>
                            Не распространяйте ложную информацию или провокационные материалы.
                        </li>
                        <li>
                            Соблюдайте законы и нормы общественной морали при загрузке контента.
                        </li>
                        <li>
                            Не публикуйте контент, призывающий к насилию, дискриминации или ненависти по любым признакам.
                        </li>
                        <li>
                            Соблюдайте конфиденциальность. Не публикуйте личную информацию других людей без их разрешения.
                        </li>
                        <li>
                            Не загружайте вредоносный или вирусный контент.
                        </li>
                    </ul>
                </p>

                <p>
                    Если вы обнаружите нарушение правил сообщества, пожалуйста, сообщите администрации для принятия мер.
                </p>

                <h2>Политика против сексуального насилия и эксплуатации детей (CSAE)</h2>
            <p>
                Платформа "animix" придерживается строгой политики нулевой терпимости к любым формам сексуального насилия и эксплуатации детей (CSAE). Мы активно противодействуем распространению любых материалов, содержащих сексуальное насилие над детьми (CSAM), и принимаем все необходимые меры для защиты детей в соответствии с законодательством Российской Федерации и международными стандартами.
                <br/><br/>
                <strong>Наши стандарты по защите детей:</strong>
                <br/><br/>
                - Мы используем передовые технологии для выявления и предотвращения загрузки материалов о сексуальном насилии над детьми (CSAM);<br/>
                - Весь контент проходит обязательную модерацию до публикации;<br/>
                - Мы сотрудничаем с правоохранительными органами для пресечения распространения CSAM;<br/>
                - Мы незамедлительно удаляем любые материалы, нарушающие права несовершеннолетних;<br/>
                <br/><br/>
                <strong>Механизм обратной связи:</strong>
                <br/><br/>
                Если вы обнаружили на нашем ресурсе материал, который может содержать признаки сексуального насилия над детьми или эксплуатации несовершеннолетних, мы настоятельно просим вас немедленно сообщить об этом одним из следующих способов:
                <br/><br/>
                - Оставьте жалобу в профиле<br/>
                - Отправьте сообщение на специальный адрес электронной почты: obdritaev@gmail.com<br/>
               
                <br/>
          
                <strong>Работа с материалами о сексуальном насилии над детьми (CSAM):</strong>
                <br/><br/>
                При выявлении материалов, содержащих признаки CSAM, мы:
                <br/><br/>
                1. Незамедлительно удаляем такие материалы с платформы;<br/>
                2. Сохраняем необходимые данные для последующей передачи в правоохранительные органы;<br/>
                3. Передаем информацию в соответствующие правоохранительные органы в соответствии с законодательством РФ;<br/>
                4. Блокируем аккаунты пользователей, загрузивших такие материалы.<br/>
                <br/><br/>
                <strong>Соблюдение законодательства о безопасности детей:</strong>
                <br/><br/>
                Наша платформа полностью соблюдает требования Федерального закона "О защите детей от информации, причиняющей вред их здоровью и развитию", а также международные стандарты по борьбе с сексуальным насилием и эксплуатацией детей. Мы регулярно обновляем наши системы защиты и политики в соответствии с изменениями в законодательстве.
                <br/><br/>
                <strong>Контактное лицо по вопросам безопасности детей:</strong>
                <br/><br/>
                По всем вопросам, связанным с защитой детей на нашей платформе, вы можете обратиться к нашему специалисту по безопасности:
                <br/><br/>
                Email: obdritaev@gmail.com<br/>
        
                <br/><br/>
                Мы принимаем ответственность за создание безопасной онлайн-среды и призываем всех пользователей сообщать о любых подозрительных материалах. Защита детей — наш общий приоритет.
            </p>
            </div>
            <Footer />
        </div>
    );
};

export default CommunityGuidelinesPage;
